module.exports = __webpack_public_path__ + "iconfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/packages/button/iconfont.ttf?t=1564473778850
// module id = 28
// module chunks = 0